import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className='flex flex-col items-center justify-center h-screen bg-white text-black px-4'>
      <h1 className='text-6xl font-bold'>404</h1>
      <p className='mt-4 text-xl'>
        Oops! The page you are looking for does not exist.
      </p>
      <Link
        to='/'
        className='mt-6 px-5 py-3 bg-blue-500 text-white rounded hover:bg-blue-600 transition'
      >
        Go Back Home
      </Link>
    </div>
  );
}
